module.exports = __webpack_public_path__ + "img/photo-projects-timedashboard.feb00f3e.jpg";